import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import { translate } from '../../utils/translations';

export function Alert({
  title,
  message,
  open,
  handleClose,
}: {
  title: string;
  message: string;
  open: boolean;
  handleClose: () => void;
}): React.JSX.Element {
  return (
    <Dialog open={open} onClose={handleClose}>
      {title && (
        <DialogTitle>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            <Grid>
              <ErrorIcon
                color="warning"
                sx={{ display: 'block', marginBottom: '2px' }}
              />
            </Grid>
            <Grid>{title}</Grid>
          </Grid>
        </DialogTitle>
      )}
      <DialogContent>
        <Typography align="center" whiteSpace="pre-line">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="outlined" onClick={handleClose}>
          {translate('COMMON.CLOSE')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
